import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import MultiSelect from "react-multi-select-component";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import { getFundByAmc } from "../../stores/services/funds.service";
// import { getBankStatement,getBankStatementOpeningBalance } from '../../stores/services/report.service';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import { exportToTxt, generateExcel, numberWithCommas } from "../../utils/customFunction";
import { useSelector } from "react-redux";
import Select from "react-select";
import { getTransactionReportSearchData } from "../../stores/services/report.service";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import html2pdf from "html2pdf.js";
import CardColComponent from "../genericCardComponent/CardColComponent";
import DividendCard from "../dividend/AnnouncementListing";

const VoucherReport = () => {
  const ColumnHeading = [
    {
      label: "Sr",
      value: "Sr",
    },
    {
      label: "Ledger Code",
      value: "Ledger Code",
    },
    {
      label: "Ledger Name",
      value: "Ledger Name",
    },
    {
      label: "Credit Amount",
      value: "Credit Amount",
    },
    {
      label: "Debit Amount",
      value: "Debit Amount",
    },
    {
      label: "Description",
      value: "Description",
    },
  ];
  const contentRef = React.useRef(null);
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"],
  });
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  let date = new Date();
  const [voucherData, setVoucherData] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [fundCode, setFundCode] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [summary, setSummary] = useState({
    totalDebits: 0,
    totalCredits: 0,
    balance: 0
  });

  const getAllAmcFunds = async () => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const ledgerData: any = JSON.parse(voucherData?.ledgers || "[]");
    const totalDebits = ledgerData?.reduce((sum, entry) => sum + parseFloat(entry?.debit_amount || 0), 0);
    const totalCredits = ledgerData?.reduce((sum, entry) => sum + parseFloat(entry?.credit_amount || 0), 0);
    const balance = totalDebits - totalCredits;

    setSummary({
      totalDebits,
      totalCredits,
      balance
    });
  }, [voucherData]);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  const searchData = async () => {
    try {
      setLoading(true);
      const fields = {
        from_date: fromDate || "",
        to_date: toDate || "",
        txn_type: "vouchers",
        status: "COMPLETED",
        amc_code: amc_code,
        fund_code: fundCode,
      }
      const searchResponse = await getTransactionReportSearchData(
        email,
        fields
      );
      if (searchResponse?.status === 200 && searchResponse?.data?.data?.length > 0) {
        setVoucherData(searchResponse?.data?.data)
      }
      else {
        toast.error("No record found!")
        setVoucherData([])
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error.response != undefined) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, selectedValues, loading]);

  const selectedFundName = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fundCode);
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
      }
      : null;
  }, [allFunds, fundCode]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const fixedOrder = [
    "Sr",
    "Ledger Code",
    "Ledger Name",
    "Credit Amount",
    "Debit Amount",
    "Description",
  ];

  const handleDownloadSampleFile = () => {

    const dataSequence = voucherData
      ?.map((ele) => {
        let ledgerProper = JSON?.parse(ele?.ledgers || "[]")
        let totalCredit = ledgerProper?.reduce((accumulator, current) => {
          return +accumulator + +current?.credit_amount;
        }, 0)
        let totalDebit = ledgerProper?.reduce((accumulator, current) => {
          return +accumulator + +current?.debit_amount;
        }, 0)
        let temp = ledgerProper?.map((ele1, index) => {
          return {
            Sr: index + 1,
            Ledger_Code: ele1?.gl_code,
            Ledger_Name: ele1?.gl_name,
            Credit_Amount: numberWithCommas(
              parseFloat(ele1?.credit_amount || 0).toFixed(4)
            ),
            Debit_Amount: numberWithCommas(
              parseFloat(ele1?.debit_amount || 0).toFixed(4)
            ),
            Description: ele1?.description?.replaceAll("JV-", "")
          };
        });
        temp?.unshift({
          Sr: selectedValues?.columns?.includes("Sr")
            ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
            : "",
          Ledger_Code:
            !selectedValues?.columns?.includes("Sr") &&
              selectedValues?.columns?.includes("Ledger_Code")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Ledger_Name:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              selectedValues?.columns?.includes("Ledger_Name")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Credit_Amount:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              selectedValues?.columns?.includes("Credit_Amount")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Debit_Amount:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              !selectedValues?.columns?.includes("Credit_Amount") &&
              selectedValues?.columns?.includes("Debit_Amount")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Description:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              !selectedValues?.columns?.includes("Credit_Amount") &&
              !selectedValues?.columns?.includes("Debit_Amount") &&
              selectedValues?.columns?.includes("Description")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
        });

        if (ledgerProper?.length > 0) {
          temp?.push(
            {
              Sr: "",
              Ledger_Code: "",
              Ledger_Name: "",
              Credit_Amount: numberWithCommas(
                parseFloat(totalCredit)?.toFixed(4)
              ),
              Debit_Amount: numberWithCommas(
                parseFloat(totalDebit)?.toFixed(4)
              ),
              Description: "",
            },

          );
        }
        else {
          temp?.push(
            {
              Sr: "No Recent Transactions!",
              Ledger_Code: "",
              Ledger_Name: "",
              Credit_Amount: "",
              Debit_Amount: "",
              Description: "",
            },
          );
        }
        return temp;
      })
      ?.flat(1);


    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Sr") {
            result[column] = entry?.Sr;
          } else if (column === "Ledger Code") {
            result[column] = entry?.Ledger_Code;
          } else if (column === "Ledger Name") {
            result[column] = entry?.Ledger_Name;
          } else if (column === "Credit Amount") {
            result[column] = entry?.Credit_Amount;
          } else if (column === "Debit Amount") {
            result[column] = entry?.Debit_Amount;
          } else if (column === "Description") {
            result[column] = entry?.Description
          }
        });
        return result;
      });

    generateExcel(
      "Voucher Report",
      "Voucher Report",
      "File",
      "File",
      "DCCL",
      [],
      reorderedColumns,
      ArrayData,
      [],
      []
    );
  };

  const handleTXT = () => {
    const dataSequence = voucherData
      ?.map((ele) => {
        let ledgerProper = JSON?.parse(ele?.ledgers || "[]")
        let totalCredit = ledgerProper?.reduce((accumulator, current) => {
          return +accumulator + +current?.credit_amount;
        }, 0)
        let totalDebit = ledgerProper?.reduce((accumulator, current) => {
          return +accumulator + +current?.debit_amount;
        }, 0)
        let temp = ledgerProper?.map((ele1, index) => {
          return {
            Sr: index + 1,
            Ledger_Code: ele1?.gl_code,
            Ledger_Name: ele1?.gl_name,
            Credit_Amount: numberWithCommas(
              parseFloat(ele1?.credit_amount || 0).toFixed(4)
            ),
            Debit_Amount: numberWithCommas(
              parseFloat(ele1?.debit_amount || 0).toFixed(4)
            ),
            Description: ele1?.description?.replaceAll("JV-", "")
          };
        });
        temp?.unshift({
          Sr: selectedValues?.columns?.includes("Sr")
            ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
            : "",
          Ledger_Code:
            !selectedValues?.columns?.includes("Sr") &&
              selectedValues?.columns?.includes("Ledger_Code")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Ledger_Name:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              selectedValues?.columns?.includes("Ledger_Name")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Credit_Amount:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              selectedValues?.columns?.includes("Credit_Amount")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Debit_Amount:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              !selectedValues?.columns?.includes("Credit_Amount") &&
              selectedValues?.columns?.includes("Debit_Amount")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
          Description:
            !selectedValues?.columns?.includes("Sr") &&
              !selectedValues?.columns?.includes("Ledger_Code") &&
              !selectedValues?.columns?.includes("Ledger_Name") &&
              !selectedValues?.columns?.includes("Credit_Amount") &&
              !selectedValues?.columns?.includes("Debit_Amount") &&
              selectedValues?.columns?.includes("Description")
              ? `${ele?.txn_id} - ${moment(ele?.created_at).format("DD MMM YYYY")}`
              : "",
        });

        if (ledgerProper?.length > 0) {
          temp?.push(
            {
              Sr: "",
              Ledger_Code: "",
              Ledger_Name: "",
              Credit_Amount: numberWithCommas(
                parseFloat(totalCredit)?.toFixed(4)
              ),
              Debit_Amount: numberWithCommas(
                parseFloat(totalDebit)?.toFixed(4)
              ),
              Description: "",
            },

          );
        }
        else {
          temp?.push(
            {
              Sr: "No Recent Transactions!",
              Ledger_Code: "",
              Ledger_Name: "",
              Credit_Amount: "",
              Debit_Amount: "",
              Description: "",
            },
          );
        }
        return temp;
      })
      ?.flat(1);


    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Sr") {
            result[column] = entry?.Sr;
          } else if (column === "Ledger Code") {
            result[column] = entry?.Ledger_Code;
          } else if (column === "Ledger Name") {
            result[column] = entry?.Ledger_Name;
          } else if (column === "Credit Amount") {
            result[column] = entry?.Credit_Amount;
          } else if (column === "Debit Amount") {
            result[column] = entry?.Debit_Amount;
          } else if (column === "Description") {
            result[column] = entry?.Description
          }
        });
        return result;
      });

    exportToTxt(
      "",
      selectedValues,
      ArrayData,
      "Voucher Report",
    );
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "Unit-Holder-Statement.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 20, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(128, 128, 128);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          pdf.text(
            'This is a computer-generated report from MACS 360. No signature is required.',
            pageWidth / 2,
            pageHeight - 10,
            { align: 'right' }
          );
        }
      })
      .save();
  };


  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Voucher Report</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFund(e?.label);
                              setFundCode(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group  ">
                          <label>Date From</label>
                          <input
                            type="date"
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            defaultValue={fromDate}
                            className="form-control"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setFromDate(date);
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group  ">
                          <label>Date To</label>
                          <input
                            type="date"
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            defaultValue={toDate}
                            className="form-control"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setToDate(date);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className=" ">
                          {/* here Search Button */}
                          <button
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              searchData();
                            }}
                            disabled={Boolean(loading)}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {voucherData?.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"Unit-Holder-Statement-" + date + ".pdf"}
                          printExcel={handleDownloadSampleFile}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${dimensionOfPages?.find(
                            (item) => item?.key == paperSizeVal
                          )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                            }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <div
                          style={{
                            margin: "0.25in"
                          }}
                          ref={contentRef}>
                          {voucherData.length > 0 ? (
                            <>
                              <ReportHeader title="Voucher Report" />

                              <DividendCard
                                toDate={moment(toDate).format("DD MMM YYYY")}
                                fromDate={moment(fromDate).format("DD MMM YYYY")}
                                resToDate={moment().format("DD MMM YYYY")}
                                fundNameIs={selectedFundName?.label}
                                reportName={"Voucher Report"}
                                report={true}
                              />

                              <div>
                                {voucherData?.length > 0 && (
                                  <table
                                    className="report"
                                    style={{
                                      color: "black",
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      tableLayout: "fixed"
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                      >
                                        {selectedValues?.columns?.includes("Sr") && (
                                          <th
                                            id="test"
                                            style={{
                                              width: "3%",
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Sr.
                                          </th>
                                        )}
                                        {selectedValues?.columns?.includes("Ledger Code") && (
                                          <th
                                            id="test"
                                            style={{
                                              width: "10%",
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Ledger Code
                                          </th>
                                        )}
                                        {selectedValues?.columns?.includes("Ledger Name") && (
                                          <th
                                            id="test"
                                            style={{
                                              width: "37%",
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Ledger Name
                                          </th>
                                        )}
                                        {selectedValues?.columns?.includes("Debit Amount") && (
                                          <th
                                            // id="test"
                                            style={{
                                              width: "15%",
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Debit Amount
                                          </th>
                                        )}
                                        {selectedValues?.columns?.includes("Credit Amount") && (
                                          <th
                                            id="test"
                                            style={{
                                              width: "15%",
                                              textAlign: "right",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Credit Amount
                                          </th>
                                        )}

                                        {selectedValues?.columns?.includes("Description") && (
                                          <th
                                            id="test"
                                            style={{
                                              width: "20%",
                                              textAlign: "left",
                                              padding: "8px 4px",
                                            }}
                                          // id="forTestNowHeaders"
                                          >
                                            Description
                                          </th>
                                        )}
                                      </tr>
                                    </thead>
                                  </table>
                                )}
                                {voucherData?.length > 0 ?
                                  voucherData?.map((ele, i) => {
                                    let ledgerProper = JSON?.parse(ele?.ledgers || "[]")
                                    let totalCredit = ledgerProper?.reduce((accumulator, current) => {
                                      return +accumulator + +current?.credit_amount;
                                    }, 0)
                                    let totalDebit = ledgerProper?.reduce((accumulator, current) => {
                                      return +accumulator + +current?.debit_amount;
                                    }, 0)
                                    return (
                                      <>
                                        <div
                                          id="test"
                                          className="float-left"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "bold"
                                          }}
                                        >
                                          {`${ele?.txn_id} - ${moment(ele?.settlement_date).format("DD MMM YYYY")} `}
                                        </div>
                                        <table
                                          className="report"
                                          style={{ color: "black" }}
                                        >
                                          {ledgerProper?.length > 0 ?
                                            <>
                                              <tbody className="report-table-body">
                                                {ledgerProper?.map(
                                                  (item: any, index: number) => {
                                                    return (
                                                      <>
                                                        <tr key={index}>
                                                          {selectedValues?.columns?.includes("Sr") && <td
                                                            style={{
                                                              width: "3%",
                                                            }}
                                                            id="test"
                                                          >
                                                            {index + 1}
                                                          </td>}
                                                          {selectedValues?.columns?.includes("Ledger Code") && <td
                                                            style={{
                                                              width: "10%",
                                                            }}
                                                            id="test"
                                                          >
                                                            {
                                                              item?.gl_code
                                                            }
                                                          </td>}
                                                          {selectedValues?.columns?.includes("Ledger Name") && <td
                                                            style={{
                                                              width: "37%",
                                                            }}
                                                            id="test"
                                                          >
                                                            {
                                                              item?.gl_name
                                                            }
                                                          </td>}
                                                          {selectedValues?.columns?.includes("Debit Amount") && <td
                                                            style={{
                                                              width: "15%",
                                                            }}
                                                            id="test"
                                                            className="text-right">
                                                            <CardColComponent
                                                              subTitle={numberWithCommas(
                                                                parseFloat(item?.debit_amount || 0).toFixed(4)
                                                              )}
                                                              amount={true}
                                                              simple={true}
                                                            />
                                                          </td>}
                                                          {selectedValues?.columns?.includes("Credit Amount") && <td
                                                            style={{
                                                              width: "15%",
                                                            }}
                                                            id="test"
                                                            className="text-right"
                                                          >
                                                            <CardColComponent
                                                              subTitle={numberWithCommas(
                                                                parseFloat(item?.credit_amount || 0).toFixed(4)
                                                              )}
                                                              amount={true}
                                                              simple={true}
                                                            />
                                                          </td>}

                                                          {selectedValues?.columns?.includes("Description") && <td
                                                            style={{
                                                              maxWidth: "20%",
                                                            }}
                                                            id="test"
                                                            className="text-left">
                                                            <span
                                                              style={{
                                                                wordBreak: "break-all"
                                                              }}
                                                            >
                                                              {
                                                                item?.description?.replaceAll("JV-", "")
                                                              }
                                                            </span>
                                                          </td>}
                                                        </tr>
                                                      </>
                                                    );
                                                  }
                                                )}
                                              </tbody>
                                              <tfoot>
                                                <tr key={i}>
                                                  {selectedValues?.columns?.includes("Sr") && (
                                                    <th
                                                      id="test"
                                                      style={{
                                                        width: "3%",
                                                        textAlign: "left",
                                                        padding: "8px 4px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                    </th>
                                                  )}
                                                  {selectedValues?.columns?.includes("Ledger Code") && (
                                                    <th
                                                      id="test"
                                                      style={{
                                                        width: "10%",
                                                        padding: "8px 4px",
                                                      }}
                                                    ></th>
                                                  )}
                                                  {selectedValues?.columns?.includes("Ledger Name") && (
                                                    <th
                                                      className="text-right"
                                                      style={{
                                                        width: "37%",
                                                        textAlign: "right",
                                                        padding: "8px 4px",
                                                        fontWeight: "bold",
                                                      }}
                                                    ></th>
                                                  )}
                                                  {selectedValues?.columns?.includes("Debit Amount") && (
                                                    <th
                                                      className="text-right"
                                                      style={{
                                                        width: "15%",
                                                        textAlign: "right",
                                                        padding: "8px 4px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      <CardColComponent
                                                        subTitle={numberWithCommas(
                                                          parseFloat(totalDebit).toFixed(2)
                                                        )}
                                                        amount={true}
                                                        simple={true}
                                                      />
                                                    </th>
                                                  )}
                                                  {selectedValues?.columns?.includes("Credit Amount") && (
                                                    <th
                                                      id="test"
                                                      style={{
                                                        width: "15%",
                                                        textAlign: "right",
                                                        padding: "8px 4px",
                                                      }}
                                                    >
                                                      <CardColComponent
                                                        subTitle={numberWithCommas(
                                                          parseFloat(totalCredit).toFixed(4)
                                                        )}
                                                        amount={true}
                                                        simple={true}
                                                      />
                                                    </th>
                                                  )}


                                                  {selectedValues?.columns?.includes("Description") && (
                                                    <th
                                                      className="text-right"
                                                      style={{
                                                        width: "20%",
                                                        textAlign: "right",
                                                        padding: "8px 4px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                    </th>
                                                  )}
                                                </tr>
                                              </tfoot>
                                            </>
                                            : (
                                              <div className="d-flex justify-content-center py-2">
                                                <b className="text-center">No Recent Transactions!</b>
                                              </div>
                                            )}
                                        </table>
                                      </>
                                    )
                                  })
                                  : null}
                              </div>


                            </>
                          ) : (
                            <div className="table-empty">
                              <BsTable className="icon" />
                              <p className="text-center text-primary empty-text">
                                No record found
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => {
                        // printReport();
                        if (pdfExportComponent.current) {
                          pdfExportComponent.current.save();
                        }
                      }}
                    >
                      Print
                    </button>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VoucherReport;
